import React, { useEffect } from 'react';
import { FeaturesPanel } from '../components/layout/MainPanels/FeaturesPanel/FeaturesPanel';

export const FeaturesScreen = () => {
    return <FeaturesPanel />;
};
